import { toast } from "react-toastify"
import axios from "axios"
import { useTranslations } from "next-intl"

interface SendMailProps  {
  name: string
  email: string
  subject: string
  message: string
}

export const sendMail = (values: SendMailProps, onSuccess: () => void, translate) => {

  toast.promise(axios.post("/api/mail-api", values), {
    success: {
      render() {
        onSuccess?.()
        return translate("toast.success")
      },
    },
    error: translate("toast.error"),
    pending: translate("toast.pending"),
  })
}